<template>
	<svg viewBox="0 0 29 32">
		<path d="M9.6 14.4h-3.2v3.2h3.2zM16.001 14.4h-3.201v3.2h3.2zM22.401 14.4h-3.201v3.2h3.2zM25.601 3.2h-1.6v-3.2h-3.2v3.2h-12.801v-3.2h-3.2v3.2h-1.6c-1.759 0.001-3.184 1.426-3.184 3.185 0 0.006 0 0.011 0 0.017v-0.001l-0.016 22.4c0 1.767 1.433 3.2 3.2 3.2v0h22.401c1.765-0.006 3.194-1.435 3.2-3.199v-22.4c-0.005-1.765-1.434-3.195-3.199-3.201h-0.001zM25.601 28.8h-22.401v-17.6h22.401z" />
	</svg>
</template>
